import { Tabs, Tab, Box } from '@mui/material';

import {
	Card,
	CardBody,
	Input,
	Pagination,
	Table,
	TableCell,
	TableContainer,
	TableFooter,
	TableHeader,
	Select,
} from '@windmill/react-ui';

//import { SidebarContext } from "context/SidebarContext";
import ExportData from 'components/common/ExportData';
import DriverTable from 'components/driver/RequestQueueTable';
import TableLoading from 'components/preloader/TableLoading';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState,useEffect } from 'react';
import DriverServices from 'services/DriverServices';

import DriverDrawer from 'components/drawer/DriverDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';

const Driver = () => {
	const { data, loading } = useAsync(DriverServices.getAllDriverRequestQueue);
	const drivers = data?.data || [];
	const [tabIndex, setTabIndex] = useState(0);
	//  const { toggleDrawer } = useContext(SidebarContext);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const { title, serviceId } = useToggleDrawer();
	const {
		driverqueueRef,
		handleChangePage,
		totalResults,
		resultsPerPage,
		dataTable,

		handleSubmitDriverqueue,
		filename,
		currentPage,
	} = useFilter(Array.isArray(data.data) ? data.data : [], itemsPerPage);
	    useEffect(() => {
    if (dataTable.length !== 0) {
      setItemsPerPage(dataTable.length);
    }
  }, [dataTable]);

	// Tab-specific data filtering
	const activeDrivers = drivers.filter((driver) => driver.status === 'active');
	const inactiveDrivers = drivers.filter(
		(driver) => driver.status === 'inactive'
	);

	const handleTabChange = (event, newValue) => {
		setTabIndex(newValue);
	};

	const getFilteredDrivers = () => {
		if (tabIndex === 1) return activeDrivers;
		if (tabIndex === 2) return inactiveDrivers;
		return drivers;
	};

	const filteredDrivers = getFilteredDrivers();

	return (
		<>
			<DeleteModal id={serviceId} title={title} />
			<MainDrawer>
				<DriverDrawer id={serviceId} />
			</MainDrawer>

			<PageTitle>Request Queue List</PageTitle>

			<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
				<CardBody>
					<div className="py-3 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex">
						<Input
							ref={driverqueueRef}
							className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
							type="search"
							name="search"
							autoComplete="off"
							placeholder="Quick Search"
							onChange={handleSubmitDriverqueue}
						/>

						<ExportData
							title="Driver"
							exportData={dataTable}
							filename={filename}
						/>
					</div>
				</CardBody>
			</Card>

			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={tabIndex} onChange={handleTabChange}>
					<Tab label="Active Drivers" />
					<Tab label="InActive Drivers" />
					<Tab label="Blocked Drivers" />
				</Tabs>
			</Box>

			{loading ? (
				<TableLoading row={12} col={6} width={190} height={20} />
			) : filteredDrivers.length ? (
				<TableContainer className="mb-8">
					<Table>
						<TableHeader className="capitalize">
							<tr>
								<TableCell>Sl.No.</TableCell>
								<TableCell>Driver Name</TableCell>
								<TableCell>Vendor ID</TableCell>
								<TableCell>Driving License</TableCell>
								<TableCell>Mobile</TableCell>
								<TableCell>Status</TableCell>
								{/* <TableCell>Block/Unblock</TableCell>
                <TableCell>Rating</TableCell>
                <TableCell className="text-right">Actions</TableCell> */}
							</tr>
						</TableHeader>
						<DriverTable
							driver={dataTable}
							perpage={itemsPerPage}
							currentPage={currentPage}
						/>
					</Table>
					<TableFooter>
						<div className="py-3 flex gap-4 items-center justify-between">
							<div className="flex-2">
								<Pagination
									totalResults={totalResults}
									resultsPerPage={resultsPerPage}
									onChange={handleChangePage}
									label="Table navigation"
								/>
							</div>
							<div className="w-40">
								<Select
									value={itemsPerPage}
									onChange={(event) => setItemsPerPage(event.target.value)}
								>
									<option value={10}>10 per page</option>
									<option value={20}>20 per page</option>
									<option value={50}>50 per page</option>
									<option value={100}>100 per page</option>
									<option value={drivers.length}>Show All</option>
								</Select>
							</div>
						</div>
					</TableFooter>
				</TableContainer>
			) : (
				<NotFound title="There are no Drivers right now." />
			)}
		</>
	);
};

export default Driver;
